import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  iconfont: 'md',
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#673ab7',
        secondary: '#9c27b0',
        accent: '#e91e63',
        error: '#ff9800',
        warning: '#ffeb3b',
        info: '#3f51b5',
        success: '#4caf50',
      },
    },
  },
})
